export const numberFormatterPTBR = (value) => {
  if (value === '-') return '-';
  if (!value) return '0';
  return new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value));
};
